<template>
  <div class="tut-taget-item">
    <div class="sample">
      <IconQrManage />
      <p>{{ t('invite_others') }}</p>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconQrManage from '@/components/icons/IconQrManage.vue';

const { t } = useI18n();
</script>
<style scoped lang="scss">
.tut-taget-item {
  background: var(--surface-overlay);
  border: 2px solid $color-navy-50;
  border-radius: $size-s;
  width: auto;
  white-space: nowrap;

  .sample {
    display: flex;
    gap: $size-s;
    padding: 0.75rem 1rem;
    fill: var(--font-default);
    color: var(--font-default);

    p {
      white-space: nowrap;
      font-weight: 500;
    }
  }
}

@include respond-to(tablet) {
  .tut-taget-item {
    .sample {
      padding: 0.75rem;
      p {
        display: none;
      }
    }
  }
}

@include respond-to(mobile-landscape) {
  .tutorial-pop {
    .tutorial-con {
      width: 100%;
      .tut-head-area {
        width: calc(100% - 98px);
        .inr {
          right: 32px;
        }
      }
    }
  }
}
</style>
